import { jsx } from 'react/jsx-runtime';
import 'react';
import { SquareImageContainer } from '@vp/swan';
import './styles.scss.js';
import { PreviewModes as k } from '../../../../node_modules/@vp/react-product-preview/dist/esm/index.js';
import { ProductImage } from '../../../../@core/components/ui/product-image/ProductImage.js';

const OrderItem=({item})=>{return jsx(SquareImageContainer,{className:"item-image-box","data-cy":"item-image-box",children:jsx(ProductImage,{item:item,previewMode:k.FirstPageOnly,priority:"purcs",imageType:"lazy"})})};

export { OrderItem };
//# sourceMappingURL=OrderItem.js.map
